import { render, staticRenderFns } from "./MetricItem.vue?vue&type=template&id=22154050&scoped=true&"
import script from "./MetricItem.vue?vue&type=script&lang=js&"
export * from "./MetricItem.vue?vue&type=script&lang=js&"
import style0 from "./MetricItem.vue?vue&type=style&index=0&id=22154050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22154050",
  null
  
)

export default component.exports